module.exports = __webpack_public_path__ + "img/logo.a7136221.png";